export const editTableTypes = {
    OPEN_CLOSE_WINDOW : 'OPEN_CLOSE_WINDOW_EDIT_TABLE',
    OPEN_CLOSE_TEMPLATE_WINDOW : 'OPEN_CLOSE_TEMPLATE_WINDOW_EDIT_TABLE',
    SET_DATA : 'SET_DATA_EDIT_TABLE',
    RESET : 'RESET'
};